import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonExtraBuilders } from "./CommonBuilders";
import { IallTypestate, initialStateTy, modalTy, SupportSubObjTy } from "./types";
const initialState:initialStateTy={
    allDiscom:[],
    isopenProfile:false,
    providertype: [],
    loading: "idle",
    modal:{} as modalTy,
    supportSubjectList: [] as SupportSubObjTy[],
    buttonLoader:"",
    projectLoader:"",
};
const reducers ={
    setDiscomList:(state:initialStateTy, {payload}:PayloadAction<IallTypestate[]>)=>{
        state.allDiscom = payload
    },
    setOPenProfile: (state:initialStateTy, { payload }: PayloadAction<boolean>) => {
        state.isopenProfile = payload
    },
    setModalHeaderFooter: (state:initialStateTy, { payload }: PayloadAction<{ title: string, btnTxt: string,secondaryBtnTxt:string,modalData?:any,modalid?:string,isheader?:boolean,tooltipContent?:React.ReactNode,tooltipId?:string }>) => {
        state.modal.title = payload.title
        state.modal.btnTxt = payload.btnTxt     
        state.modal.secondaryBtnTxt = payload.secondaryBtnTxt
        state.modal.modalid = payload.modalid
        state.modal.isheader = payload.isheader
        state.modal.modalData = payload.modalData!
        state.modal.tooltipContent = payload.tooltipContent
        state.modal.tooltipId = payload.tooltipId
    },
    toggleModalState: (state:initialStateTy, { payload }: PayloadAction<boolean>) => {
        state.modal.isOpen = payload
    },
    setButtonLoader:(state:initialStateTy,{payload}:PayloadAction<string>)=>{
        state.buttonLoader = payload
    },
     setProjectLoader:(state:initialStateTy,{payload}:PayloadAction<string>)=>{
        state.buttonLoader = payload
    },
};
const CommonReducers = createSlice({
    name:"commonReducers",
    initialState,
    reducers,
    extraReducers:CommonExtraBuilders
});

export const {setButtonLoader,setOPenProfile,setProjectLoader,setDiscomList,setModalHeaderFooter,toggleModalState} = CommonReducers.actions;
export default CommonReducers.reducer
